import { FormlySelectOption } from '@ngx-formly/core/select';

export const initSelectOptions = (...items: any[]): FormlySelectOption[] => items.map(v => ({ label: v, value: v }));
